export function updateSlideAccessibility(container, swiper) {
    const slides = container.querySelectorAll('.swiper-slide');
    slides.forEach((slide, index) => {
        const isActive = index === swiper.activeIndex;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.querySelectorAll('a, button').forEach((el) => {
            el.setAttribute('tabindex', isActive ? '0' : '-1');
        });
    });
}
